enum TipoBeneficio {
    Desconto = 0,
    Comissao = 1
}

export default TipoBeneficio;